import React, { useState } from 'react';

import './copy-link.scss';

function CopyLink({ link, reset }) {
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(link.bam_link.encoded_auction_url).then(() => {
      setCopied(true);
    });
  }

  return (
    <div className="copy-link">
      <div className="header">Create Narrativ Links</div>
      <div className="product-url">{link.bam_link.url}</div>
      <div className="copy-field">
        <div className={`copy-field-inner ${copied ? 'copied' : ''}`}>
          <div className="link">{link.bam_link.encoded_auction_url}</div>
        </div>
      </div>
      <div className="copy-btn" onClick={copy}>
        {copied ? 'Copied!' : 'Copy Link'}
      </div>
      <div className="reset-btn" onClick={reset}>
        Create Another Link
      </div>
    </div>
  );
}

export default CopyLink;
